module.exports = __webpack_public_path__ + "static/media/asist.carretera.cb7103ed.png";